module.exports = __webpack_public_path__ + "img/pgAct.982aaac7.webp";